import axios from 'axios'

/**
 *
 * @returns the authenticated member's id (string) or null if the user is not authenticated
 */
export async function getAuthenticatedMemberId() {
  const response = await axios.get('/umbraco/api/account/GetAuthenticatedMemberId')
  if (response.status === 200) {
    return response.data
  }
  return null
}

/**
 * @param {string} memberId
 */
export async function getPreviousSalaryData(memberId) {
  const response = await axios.get(
    `/umbraco/api/salaryApp/GetPreviousSalaryDataForMember?memberId=${memberId}`,
  )
  if (response.status == 200) {
    return response.data
  }
  return null
}

/**
 * @param {{
 * education: int
 * position: int
 * age: int
 * weeklyHours: int
 * sector: int
 * region: int
 * personelResponsibility: int
 * memberNo: string
 * leadData: {
 *  firstName: string
 *  lastName: string
 *  email: string
 *  phone: string
 *  birthdate: {
 *   day: int
 *   month: int
 *   year: int
 *  }
 *  lineOfBusiness: string
 *  company: string
 * }
 * }} salaryCalculationRequestModel
 */
export async function getCalculatedSalaryEstimate(salaryCalculationRequestModel) {
  const response = await axios.post(
    '/umbraco/api/salaryApp/GetCalculatedSalaryEstimate',
    salaryCalculationRequestModel,
  )
  return response.data
}

export async function getMasterDataForMember(culture) {
  const response = await axios.get(`/umbraco/api/salaryApp/GetMasterDataForMember`, {
    params: { culture },
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    }
  })
  return response.data
}

/**
 * @param {{
 * memberId: string
 * education: {
 *  id: int
 *  name?: string
 * }
 * personelResponsibility: {
 *  id: int
 *  name?: string
 * }
 * workAreas: {
 *  workAreaId: int
 *  workAreaName?: string
 *  positionId: int
 *  positionName?: string
 * }[]
 * sector: {
 *  id: int
 *  name?: string
 * }
 * }} masterDataModel
 */
export async function updateMasterDataForMember(masterDataModel) {
  const response = await axios.post(
    '/umbraco/api/salaryApp/UpdateMasterDataForMember',
    masterDataModel,
  )
  return response
}

export async function sendEmailToJura(requestModel) {
  const response = await axios.post('/umbraco/api/salaryApp/SendEmailToJura', requestModel)
  return response
}
export async function sendEmailToUser(requestModel) {
  const response = await axios.post('/umbraco/api/salaryApp/SendEmailToUser', requestModel)
  return response
}
